import { ActionType } from '../../../definitions/types/ActionType';
import { EntityType } from '../../../definitions/types/Entity';
import { StateType } from '../../../definitions/types/StateType';
import { urlFromState } from '../../../utils/helpers/urlFromState';

export const addReducer = (state: StateType, action: ActionType): StateType => {
  const payload: EntityType = action.payload as EntityType;
  let entityExists = false;

  const newState = {
    ...state,
  };

  state.entities.forEach((entity) => {
    if (entity.type === payload.type && entity.id === payload.id) {
      entityExists = true;
    }
  });

  if (!state.entities.length) {
    newState.selected = {
      ...payload,
      number: '1',
    };
  }

  if (!entityExists) {
    newState.entities = [...state.entities, payload];
  }

  newState.url = urlFromState(newState);

  return newState;
};
